import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Content = styled.div`
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
  margin-bottom: 1rem;
`;

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.5rem;
  border: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.5rem;
  outline: none;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  transition: all 0.2s;

  &:focus {
    border-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
    box-shadow: 0 0 0 2px ${(props) => (props.theme.colors?.primary || '#3b82f6')}20;
  }
`;

export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 15rem;
  overflow-y: auto;
  margin-bottom: 1rem;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
`;

export const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const UserItem = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${({ $selected, theme }) =>
    $selected ? (theme.colors?.primary || '#3b82f6') + '20' : 'transparent'};

  &:hover {
    background-color: ${({ $selected, theme }) =>
      $selected
        ? (theme.colors?.primary || '#3b82f6') + '30'
        : theme.colors?.gray01 || '#f5f5f5'};
  }
`;

export const Checkbox = styled.div<{ $selected: boolean }>`
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid
    ${({ $selected, theme }) =>
      $selected ? theme.colors?.primary || '#3b82f6' : theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.25rem;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.colors?.primary || '#3b82f6' : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors?.white01};
  margin-right: 0.75rem;
  flex-shrink: 0;
`;

export const AvatarContainer = styled.div`
  position: relative;
  margin-right: 0.75rem;
`;

export const Avatar = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const OnlineBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.75rem;
  height: 0.75rem;
  background-color: ${(props) => props.theme.colors?.success};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors?.white01 || '#ffffff'};
`;

export const OfflineBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.75rem;
  height: 0.75rem;
  background-color: ${(props) => props.theme.colors?.danger};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors?.white01 || '#ffffff'};
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.h3`
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  margin-bottom: 0.25rem;
`;

export const UserStatus = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
`;

export const MessageWrapper = styled.div`
  margin-bottom: 1rem;
`;

export const MessageLabel = styled.label`
  display: block;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  margin-bottom: 0.5rem;
`;

export const MessageTextarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.5rem;
  outline: none;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-family: inherit;
  resize: vertical;
  transition: all 0.2s;

  &:focus {
    border-color: ${(props) => props.theme.colors?.primary || '#3b82f6'};
    box-shadow: 0 0 0 2px ${(props) => (props.theme.colors?.primary || '#3b82f6')}20;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
`;

export const SelectedCount = styled.span`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  color: ${(props) => props.theme.colors?.text?.secondary || '#6b7280'};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const CancelButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid ${(props) => props.theme.colors?.gray02 || '#e5e7eb'};
  border-radius: 0.5rem;
  background: ${(props) => props.theme.colors?.white01 || '#ffffff'};
  color: ${(props) => props.theme.colors?.text?.primary || '#111827'};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors?.gray01 || '#f5f5f5'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  background: ${(props) => props.theme.colors?.primary || '#3b82f6'};
  color: ${({ theme }) => theme.colors?.white01};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 500;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

